import React from 'react';
import { loadMissions } from '../engine/GameState';

export default function MissionsScreen({ onClose, currentMissions }) {
  const missions = currentMissions || loadMissions();

  const MISSION_ICONS = {
    coins: '🪙',
    distance: '🏃',
    no_crash: '🛡️',
    powerups: '⚡',
    score: '⭐',
  };

  return (
    <div
      className="absolute inset-0 z-30 flex items-center justify-center"
      style={{ background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(4px)' }}
    >
      <div
        className="w-full max-w-sm mx-4 rounded-2xl overflow-hidden"
        style={{
          background: 'linear-gradient(135deg, #1a0a2e, #2d1a4e)',
          border: '2px solid rgba(99,102,241,0.5)',
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div className="flex items-center justify-between p-4 border-b" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
          <h2 className="font-heading font-bold text-xl text-white">🎯 Missions</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ background: 'rgba(255,255,255,0.1)', color: 'white' }}
          >
            ✕
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {missions?.map(mission => {
            const progress = Math.min(mission?.progress / mission?.target, 1);
            return (
              <div
                key={mission?.id}
                className="p-4 rounded-xl"
                style={{
                  background: mission?.completed ? 'rgba(16,185,129,0.1)' : 'rgba(255,255,255,0.05)',
                  border: mission?.completed ? '1px solid rgba(16,185,129,0.4)' : '1px solid rgba(255,255,255,0.1)',
                }}
              >
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <span className="text-xl">{MISSION_ICONS?.[mission?.type] || '🎯'}</span>
                    <div>
                      <p className="font-body text-sm font-semibold text-white">{mission?.name}</p>
                      <p className="font-caption text-xs" style={{ color: 'rgba(255,255,255,0.5)' }}>{mission?.desc}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="font-data text-sm font-bold" style={{ color: '#f59e0b' }}>+{mission?.reward}</p>
                    <p className="font-caption text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>🪙</p>
                  </div>
                </div>
                <div className="w-full h-2 rounded-full" style={{ background: 'rgba(255,255,255,0.1)' }}>
                  <div
                    className="h-full rounded-full transition-all"
                    style={{
                      width: `${progress * 100}%`,
                      background: mission?.completed ? '#10b981' : 'linear-gradient(90deg, #6366f1, #8b5cf6)',
                    }}
                  />
                </div>
                <div className="flex justify-between mt-1">
                  <span className="font-caption text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>
                    {mission?.progress} / {mission?.target}
                  </span>
                  {mission?.completed && (
                    <span className="font-caption text-xs" style={{ color: '#10b981' }}>✓ Complete!</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
